export const DEFAULT_MESSAGE = `Once you type in an amount the payroll deduction amount will be calculated`